// extracted by mini-css-extract-plugin
export default {"container":"footer_container__QbKC-","copyright":"footer_copyright__izYg2","footer":"footer_footer__NjMd5"};